import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PremiumFeatureDialogService } from 'src/app/core/premium-feature-dialog.service';

@Component({
  selector: 'app-premium-feature-dialog',
  templateUrl: './premium-feature-dialog.component.html',
  styleUrls: ['./premium-feature-dialog.component.scss'],
  standalone: false
})
export class PremiumFeatureDialogComponent {

  isVisible: boolean = false;
  title: string = '';
  text: string = '';


  constructor(
    private router: Router,
    private dialogService: PremiumFeatureDialogService
  ) {}

  ngOnInit() {
    this.dialogService.isVisible$.subscribe((isVisible) => {
      this.isVisible = isVisible;
    });
    this.dialogService.title$.subscribe((title) => {
      this.title = title;
    });
    this.dialogService.text$.subscribe((text) => {
      this.text = text;
    });
  }

  openGetPremium() {
    this.isVisible = false;
    this.router.navigate(['get-premium']);
  }
}